import React, { useState, useEffect, useRef } from "react";

// ==========================================
// 1. ICONS (Inline SVGs for Portability)
// ==========================================
const Icons = {
  ArrowLeft: (props) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="m12 19-7-7 7-7" /><path d="M19 12H5" />
    </svg>
  ),
  Briefcase: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect width="20" height="14" x="2" y="7" rx="2" ry="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  ),
  Building2: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" /><path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" /><path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" /><path d="M10 6h4" /><path d="M10 10h4" /><path d="M10 14h4" /><path d="M10 18h4" />
    </svg>
  ),
  BadgeCheck: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.78 4.78 4 4 0 0 1-6.74 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z" /><path d="m9 12 2 2 4-4" />
    </svg>
  ),
  UploadCloud: (props) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" /><path d="M12 12v9" /><path d="m16 16-4-4-4 4" />
    </svg>
  ),
  ChevronRight: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="m9 18 6-6-6-6" />
    </svg>
  ),
  User: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Mail: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect width="20" height="16" x="2" y="4" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </svg>
  ),
  MapPin: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" /><circle cx="12" cy="10" r="3" />
    </svg>
  ),
  Calendar: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect width="18" height="18" x="3" y="4" rx="2" ry="2" /><line x1="16" x2="16" y1="2" y2="6" /><line x1="8" x2="8" y1="2" y2="6" /><line x1="3" x2="21" y1="10" y2="10" />
    </svg>
  ),
  Zap: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </svg>
  ),
  FileText: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" /><polyline points="14 2 14 8 20 8" /><line x1="16" x2="8" y1="13" y2="13" /><line x1="16" x2="8" y1="17" y2="17" /><line x1="10" x2="8" y1="9" y2="9" />
    </svg>
  ),
  CheckCircle: (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  Loader2: (props) => (
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
  ),
  Check: (props) => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  Sparkles: (props) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="none" {...props}>
      <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
    </svg>
  ),
  X: (props) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M18 6 6 18" /><path d="m6 6 18 12" />
    </svg>
  ),
  Info: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="12" cy="12" r="10" /><path d="M12 16v-4" /><path d="M12 8h.01" />
    </svg>
  ),
  Clock: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  Download: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" x2="12" y1="15" y2="3" />
    </svg>
  ),
  Share2: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><line x1="8.59" x2="15.42" y1="13.51" y2="17.49" /><line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
    </svg>
  ),
  UserPlus: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="8.5" cy="7" r="4" /><line x1="20" x2="20" y1="8" y2="14" /><line x1="23" x2="17" y1="11" y2="11" />
    </svg>
  ),
  Edit: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
    </svg>
  ),
  Link: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  ),
  Linkedin: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" /><rect width="4" height="12" x="2" y="9" /><circle cx="4" cy="4" r="2" />
    </svg>
  ),
  WhatsApp: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="12" cy="12" r="10" /><path d="M16.5 16.5 12 12" />
    </svg>
  ),
  ThumbsUp: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M7 10v12" /><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z" />
    </svg>
  ),
  ThumbsUpSolid: (props) => (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M14 9V5C14 3.34315 12.6569 2 11 2L7 11V22H18.28C19.3845 22 20.28 21.1046 20.28 20L21.66 11C21.66 9.89543 20.7645 9 19.66 9H14Z" fill="#E28743"/>
      <path d="M7 22H4C2.89543 22 2 21.1046 2 20V13C2 11.8954 2.89543 11 4 11H7V22Z" fill="#475467"/>
    </svg>
  ),
  Money: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M6 3h12" /><path d="M6 8h12" /><path d="m6 13 8.5 10" /><path d="M9 13c6.668 0 6.668-9 0-9H6" />
    </svg>
  ),
  Star: (props) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
};

// --- 2. CUSTOM CSS ---
const CUSTOM_CSS = `
/*
 * ========================================================================
 * LYWO ENTERPRISE STYLE GUIDE - MAIN CSS (main.css)
 * ========================================================================
 * * INSTRUCTIONS FOR USE:
 * 1. Global Setup: Include this file in your project's main layout.
 * * 2. Layout Density Engine: By default, the layout uses "Comfortable" spacing. 
 * To seamlessly switch the entire application to "Compact" mode, simply add 
 * the data attribute to your root element:
 * <html data-density="compact"> or <body data-density="compact">
 * * 3. Dark Mode Support: The UI is driven by Semantic Tokens (e.g. var(--brand-bg)).
 * To implement dark mode, simply overwrite these semantic variables via JS
 * on the :root element. No class name changes required.
 * * 4. Dynamic Forms: Wrap vertical or horizontal form rows in <div class="form-flex-col"> 
 * to automatically inherit dynamic gap spacing from the Density Engine.
 * ========================================================================
 */

@charset "UTF-8";
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css");
/* 2025 Best Practice: Adopting Variable Fonts (Inter) for dynamic weight/width */
@import url("https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap");

:root {
  /* ========================================================= */
  /* 1. PRIMITIVE TOKENS (Raw Visual Values)                   */
  /* Avoid using these directly in UI components. Use Semantic */
  /* tokens instead to ensure Dark Mode compatibility.         */
  /* ========================================================= */
  --color-blue-500: #3B7CF2; 
  --color-blue-400: #5a91f5;
  --color-indigo-100: #eef2ff;
  --color-green-100: #d1e7dd;
  --color-green-700: #198754;
  --color-yellow-100: #fff3cd;
  --color-yellow-700: #856404;
  --color-red-100: #f8d7da;
  --color-red-700: #dc3545;

  --color-gray-50: #F3F5F9; 
  --color-gray-100: #e5e7eb;
  --color-gray-200: #d0d5dd;
  --color-gray-700: #667085;
  --color-gray-800: #344054; 
  --color-gray-900: #1F222A; 
  
  --color-black: #000000;
  --color-black-88: #000000E0;

  /* ========================================================= */
  /* 2. SEMANTIC TOKENS (Contextual Roles for Theming)         */
  /* Apply these to components. Overwrite these in Dark Mode.  */
  /* ========================================================= */
  --brand-primary: var(--color-blue-500);
  --brand-accent: #081DA5; 
  --brand-bg: var(--color-gray-50);
  --brand-text: var(--color-gray-900);
  
  --surface-bg: #ffffff;
  --surface-bg-hover: var(--color-gray-50);
  --surface-bg-alpha: rgba(255, 255, 255, 0.85);

  --color-info-bg: var(--color-indigo-100);
  --color-success-bg: var(--color-green-100);
  --color-success-text: var(--color-green-700);
  --color-warning-bg: var(--color-yellow-100);
  --color-warning-text: var(--color-yellow-700);
  --color-danger-bg: var(--color-red-100);
  --color-danger-text: var(--color-red-700);
  
  --ui-gray-bg: var(--color-gray-100);
  --ui-border: var(--color-gray-200);
  --ui-text-muted: var(--color-gray-700);
  --ui-text-dark: var(--color-gray-800);

  /* --- Dimensions & Z-Index --- */
  --radius-md: 0.5rem;
  --radius-lg: 0.75rem;
  --modal-height: 650px;
  --ff-z-index-app-header: 100;
  --ff-z-index-dropdown: 1050;
  --ff-z-index-modal: 1100;
  --ff-z-index-toast: 1200;

  /* ========================================================= */
  /* 3. TYPOGRAPHY & DYNAMIC SPACING TOKENS                    */
  /* These variables natively power the Layout Density Engine. */
  /* ========================================================= */
  --type-ratio: 1.125;
  --font-size-base: 0.6875rem; 
  --font-size-sm: calc(var(--font-size-base) / var(--type-ratio)); 
  --font-size-h4: calc(var(--font-size-base) * var(--type-ratio) * var(--type-ratio)); 
  --font-size-h3: clamp(1rem, 0.9rem + 0.5vw, 1.1875rem); 
  --font-size-h2: clamp(1.25rem, 1.1rem + 1vw, 1.5rem); 
  --font-size-h1: clamp(1.5rem, 1.2rem + 1.5vw, 1.9375rem); 

  --font-family-base: 'Inter', sans-serif;
  --font-family-report: "Calibri", Arial, sans-serif;
  --ff-font-family-inter-regular: "Inter-Regular", sans-serif;
  --ff-font-family-job: "Source Sans Pro", sans-serif;
  --ff-font-family-fallback: Arial, sans-serif;
  
  /* DEFAULT (COMFORTABLE) DENSITY */
  --line-height-heading: 1.35; 
  --line-height-body: 1.7;     
  --line-height-sm: 1.5;       
  --margin-base: 1.5rem;
  --padding-card: 1.5rem;
  --gap-bento: 1.5rem;
  
  /* Dynamic Input Scaling */
  --input-min-height: 38px;
  --input-padding-y: 0.5rem;
  --input-padding-x: 0.75rem;

  /* ========================================================= */
  /* 4. EXTENDED & LEGACY TOKENS (Consolidated)                */
  /* ========================================================= */
  --color-gray-600: #475467;
  --color-gray-400: #9ca3af;
  --color-peach-bg: #ffe6d5;
  --color-slate-600: #51607A;
  --color-rose-400: #FB7185;
  --color-green-600: #009746;
  --color-blue-deep: #0047FF;
  --color-dark-navy: #1e293b;
  --color-slate-500: #64748b;
  --color-slate-700: #334155;
  --color-slate-400: #475569;
  --color-blue-navy: #1e3a8a;
  --color-highlight-blue: #3b82f6;
  --color-indigo-500: #6366f1;
  --color-sidebar-border: #d7e2ff;
  --color-sidebar-accent: #081da5;
}

/* * COMPACT DENSITY OVERRIDES */
[data-density="compact"] {
  --line-height-heading: 1.14; 
  --line-height-body: 1.4;     
  --margin-base: 0.75rem;
  --padding-card: 1rem;
  --gap-bento: 0.75rem;
}

html { 
  scroll-behavior: smooth; 
  font-size: 100%; 
}

body { 
  margin: 0; padding: 0; 
  font-family: var(--font-family-base) !important; 
  font-size: var(--font-size-base); 
  background-color: var(--brand-bg); 
  -webkit-font-smoothing: antialiased; 
  line-height: var(--line-height-body); 
  color: var(--brand-text);
  font-weight: 400;
}

/* 2025 Best Practice: Override Bootstrap classes for Dark Mode Compatibility */
.bg-white { background-color: var(--surface-bg) !important; }
.bg-light { background-color: var(--ui-gray-bg) !important; }
.text-dark { color: var(--brand-text) !important; }
.border { border-color: var(--ui-border) !important; }

/* Responsive Images */
img { max-width: 100%; height: auto; }

/* Global Utilities */
.text-truncate { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

/* * BENTO GRID LAYOUTS */
.bento-grid { display: grid; grid-template-columns: 1fr; gap: var(--gap-bento); align-items: stretch; transition: gap 0.3s ease; }
@media (min-width: 768px) { .bento-grid { grid-template-columns: repeat(2, 1fr); } }
@media (min-width: 1024px) { .bento-grid { grid-template-columns: repeat(3, 1fr); } }

/* * DYNAMIC FORM LAYOUTS */
.form-flex-col { display: flex; flex-direction: column; gap: var(--margin-base); transition: gap 0.3s ease; }
.job-description-form { display: flex; flex-direction: column; gap: var(--margin-base); transition: gap 0.3s ease; }

/* ========================================= */
/* TYPOGRAPHY GLOBAL STYLES                  */
/* ========================================= */

h1, .h1 { font-size: var(--font-size-h1) !important; line-height: var(--line-height-heading); font-weight: 700; letter-spacing: -0.02em; margin-bottom: calc(var(--margin-base) * 0.5); color: var(--brand-text); transition: margin 0.3s ease; }
h2, .h2 { font-size: var(--font-size-h2) !important; line-height: var(--line-height-heading); font-weight: 700; letter-spacing: -0.01em; margin-bottom: calc(var(--margin-base) * 0.5); color: var(--brand-text); transition: margin 0.3s ease; }
h3, .h3 { font-size: var(--font-size-h3) !important; line-height: var(--line-height-heading); font-weight: 700; margin-bottom: calc(var(--margin-base) * 0.5); color: var(--brand-text); transition: margin 0.3s ease; }
h4, .h4 { font-size: var(--font-size-h4) !important; line-height: var(--line-height-heading); font-weight: 700; margin-bottom: calc(var(--margin-base) * 0.5); color: var(--brand-text); transition: margin 0.3s ease; }

.text-sm { font-size: var(--font-size-sm) !important; line-height: var(--line-height-sm); }
.text-base { font-size: var(--font-size-base) !important; line-height: var(--line-height-body); }
.text-lg { font-size: var(--font-size-h4) !important; }
.text-xl { font-size: var(--font-size-h3) !important; }
.text-2xl { font-size: var(--font-size-h2) !important; }
.text-3xl { font-size: var(--font-size-h1) !important; }

p { font-size: var(--font-size-base); line-height: var(--line-height-body); text-align: left; margin-bottom: 1rem; color: var(--brand-text); transition: margin 0.3s ease; }

.fw-bold { font-weight: 700 !important; }
.fw-normal { font-weight: 400 !important; }
.fw-medium { font-weight: 500 !important; }

/* Text Colors */
.text-primary { color: var(--brand-primary) !important; }
.text-danger { color: var(--color-danger-text) !important; }
.text-warning { color: var(--color-warning-text) !important; }
.text-info { color: var(--color-indigo-500) !important; }
.text-success { color: var(--color-success-text) !important; }
.text-muted { color: var(--ui-text-muted) !important; }
.text-center { text-align: center !important; }

.icon-baseline { margin-top: 4px; display: inline-block; line-height: 0; }

/* ========================================= */
/* LAYOUT & CORE COMPONENTS                  */
/* ========================================= */
.ds-wrapper { background-color: var(--brand-bg); min-height: 100vh; display: flex; flex-direction: column; min-width: 320px; transition: background-color 0.3s; }
.ds-wrapper.desktop-preview { min-width: 1024px; overflow-x: auto; }
.ds-header { background: var(--surface-bg); border-bottom: 1px solid var(--ui-border); position: sticky; top: 0; z-index: var(--ff-z-index-app-header); transition: background-color 0.3s; }
.ds-brand-row { display: flex; justify-content: space-between; align-items: center; padding: 0.75rem 1.5rem; border-bottom: 1px solid var(--ui-gray-bg); }
.ds-nav-row { padding: 0 1.5rem; overflow-x: auto; white-space: nowrap; background: var(--surface-bg); }
.ds-content { flex: 1; padding: 2rem; width: 100%; max-width: 1200px; margin: 0 auto; transition: background-color 0.3s; }

/* Buttons & Navigation */
.btn { font-weight: 600; padding: 0.375rem 1rem; border-radius: var(--radius-md); display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem; transition: 0.2s; font-size: var(--font-size-base) !important; cursor: pointer; border: 1px solid transparent; }
.btn-primary { background-color: var(--brand-primary); border-color: var(--brand-primary); color: #fff; box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05); }
.btn-primary:disabled { background-color: var(--ui-gray-bg); border-color: var(--ui-border); color: var(--ui-text-muted); cursor: not-allowed; }
.btn-outline-primary { color: var(--brand-primary); border: 1px solid var(--brand-primary) !important; background: var(--surface-bg); }
.btn-icon { padding: 8px; color: var(--ui-text-muted); border: 1px solid var(--ui-border); background: var(--surface-bg); }
.btn-ghost { background: none !important; border: none !important; cursor: pointer; padding: 0; line-height: 1; }
.btn-skip { background: transparent; border: none; color: var(--brand-primary); font-size: var(--font-size-base) !important; font-weight: 600; cursor: pointer; padding: 4px 8px; text-decoration: underline; text-decoration-thickness: 3px; text-underline-offset: 4px; text-decoration-color: rgba(59, 124, 242, 0.25); transition: all 0.2s ease; }
.text-action-link { background: transparent; border: none; padding: 0; color: var(--brand-primary); font-size: var(--font-size-base); font-weight: 500; cursor: pointer; transition: all 0.2s ease; display: inline-flex; align-items: center; text-decoration: none; }

@media (hover: hover) {
  .btn-primary:not(:disabled):hover { filter: brightness(0.9); }
  .btn-outline-primary:hover { background-color: var(--color-info-bg); }
  .btn-icon:hover { color: var(--brand-primary); border-color: var(--brand-primary); background: var(--color-info-bg); }
  .text-action-link:hover { text-decoration: underline; text-underline-offset: 4px; }
}

/* Tabs & Navigation Menus */
.nav-tabs-horizontal { display: flex; gap: 2rem; border-bottom: none; margin: 0; padding: 0; list-style: none; }
.nav-item-h { padding: 1rem 0.25rem; cursor: pointer; color: var(--ui-text-muted); font-weight: 500; font-size: var(--font-size-base); border-bottom: 2px solid transparent; transition: all 0.2s; display: flex; align-items: center; gap: 0.5rem; white-space: nowrap; flex-shrink: 0; }
.nav-item-h.active { color: var(--brand-primary); border-bottom-color: var(--brand-primary); }
@media (hover: hover) { .nav-item-h:hover { color: var(--brand-primary); } }

/* Context Menu */
.context-menu { background: var(--surface-bg); border: 1px solid var(--ui-border); border-radius: var(--radius-md); box-shadow: 0 4px 12px -2px rgba(0,0,0,0.1); min-width: 160px; padding: 4px 0; overflow: hidden; display: flex; flex-direction: column; height: max-content; }
.context-menu-item { display: flex; align-items: center; justify-content: flex-start; text-align: left; gap: 8px; padding: 0.375rem 0.75rem; font-size: var(--font-size-base); font-weight: 500; color: var(--brand-text); cursor: pointer; transition: 0.1s; white-space: nowrap; width: 100%; border: none; background: transparent; }
.context-menu-item svg { flex-shrink: 0; }
.context-menu-item.danger { color: var(--color-danger-text); }
@media (hover: hover) {
  .context-menu-item:hover { background-color: var(--ui-gray-bg); color: var(--brand-primary); }
  .context-menu-item.danger:hover { background-color: var(--color-danger-bg); }
}

/* Pagination */
.pagination-wrapper { display: flex; justify-content: flex-end; align-items: center; gap: var(--gap-bento); padding: var(--margin-base) 0; width: 100%; }
.pagination-nav { display: flex; align-items: center; gap: 0.5rem; }
.page-nav-link { display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; color: var(--ui-text-muted); cursor: pointer; background: transparent; border: 1px solid transparent; border-radius: 6px; font-size: var(--font-size-base); transition: all 0.2s; }
.page-nav-link.disabled { opacity: 0.4; cursor: not-allowed; pointer-events: none; }
@media (hover: hover) { .page-nav-link:hover { color: var(--brand-primary); background-color: var(--ui-gray-bg); } }
.page-number { font-weight: 500; font-size: var(--font-size-base); color: var(--brand-text); cursor: pointer; }
.page-select-wrapper { position: relative; display: flex; align-items: center; }
.page-select { appearance: none; padding: 0.375rem 24px 0.375rem 8px; border: 1px solid var(--ui-border); border-radius: 6px; background: var(--surface-bg); font-size: var(--font-size-base); font-weight: 500; color: var(--brand-text); cursor: pointer; min-width: 60px; line-height: 1.5; min-height: 32px; transition: all 0.3s ease; }
.page-select:focus { outline: none; border-color: var(--brand-primary); }
.page-select-icon { position: absolute; right: 6px; pointer-events: none; width: 12px; height: 12px; color: var(--ui-text-muted); }

/* Forms & Inputs */
.form-control, .form-select { color: var(--brand-text) !important; font-size: var(--font-size-base) !important; font-weight: 400 !important; border-radius: 8px !important; min-height: 38px !important; border: 1px solid var(--ui-border) !important; padding: 0.375rem 0.75rem !important; background: var(--surface-bg); width: 100%; line-height: 1.5 !important; transition: all 0.3s ease; }
.form-control::placeholder, .form-select::placeholder { font-size: var(--font-size-base) !important; font-weight: 400 !important; color: var(--color-gray-400) !important; }
.form-control:focus { outline: none; border-color: var(--brand-primary); box-shadow: 0 0 0 4px rgba(59, 124, 242, 0.15); }
.form-label { font-size: var(--font-size-base) !important; font-weight: 700 !important; color: var(--brand-text); margin-bottom: 6px; display: block; }

/* Custom Controls */
.topic-chip { padding: 4px 12px; border-radius: 16px; font-size: var(--font-size-sm); font-weight: 500; background: var(--ui-gray-bg); color: var(--ui-text-dark); border: 1px solid var(--ui-border); cursor: pointer; transition: all 0.2s ease; }
.topic-chip.selected { background: var(--color-info-bg); color: var(--brand-primary); border-color: var(--brand-primary); }

.custom-switch-wrap { display: flex; align-items: center; cursor: pointer; user-select: none; gap: 8px; }
.switch-input { position: absolute; opacity: 0; width: 0; height: 0; }
.switch-slider { position: relative; display: inline-block; width: 36px; height: 20px; background-color: var(--ui-border); border-radius: 34px; transition: background-color 0.3s; }
.switch-slider::before { position: absolute; content: ""; height: 16px; width: 16px; left: 2px; bottom: 2px; background-color: #fff; transition: transform 0.3s; border-radius: 50%; box-shadow: 0 1px 2px rgba(0,0,0,0.2); }
.switch-input:checked + .switch-slider { background-color: var(--brand-primary); }
.switch-input:checked + .switch-slider::before { transform: translateX(16px); }

.custom-checkbox-wrap { display: flex; align-items: center; gap: 8px; cursor: pointer; user-select: none; }
.custom-checkbox { width: 18px; height: 18px; border-radius: 4px; border: 1px solid var(--ui-border); appearance: none; -webkit-appearance: none; outline: none; cursor: pointer; position: relative; background-color: var(--surface-bg); transition: all 0.2s; flex-shrink: 0; }
.custom-checkbox:checked { border-color: var(--brand-primary); background-color: var(--color-info-bg); }
.custom-checkbox:checked::after { content: "✓"; font-size: 12px; font-weight: bold; color: var(--brand-primary); position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); }

.custom-radio { width: 18px; height: 18px; appearance: none; -webkit-appearance: none; border: 1px solid var(--ui-border); border-radius: 50%; outline: none; cursor: pointer; position: relative; background: var(--surface-bg); transition: all 0.2s; flex-shrink: 0;}
.custom-radio:checked { border-color: var(--brand-primary); border-width: 5px; }

/* Custom Range Slider */
.custom-range { -webkit-appearance: none; appearance: none; width: 100%; height: 6px; background: var(--ui-border); border-radius: 4px; outline: none; transition: background 0.3s; }
.custom-range::-webkit-slider-thumb { -webkit-appearance: none; appearance: none; width: 18px; height: 18px; border-radius: 50%; background: var(--brand-primary); cursor: pointer; border: 2px solid var(--surface-bg); box-shadow: 0 1px 3px rgba(0,0,0,0.3); transition: transform 0.1s; }
.custom-range::-webkit-slider-thumb:hover { transform: scale(1.15); }

/* TOUCH TARGET EXPANSION */
@media (pointer: coarse) {
  .btn, .form-control, .form-select, .page-nav-link, .nav-item-h, .context-menu-item, .btn-skip, .text-action-link, .custom-switch-wrap, .custom-checkbox-wrap, .btn-tag-toggle, .tag-label-item {
    min-height: 44px !important;
  }
}

/* * CARDS & CONTAINERS */
.card-std { background: var(--surface-bg); border: 1px solid var(--ui-border); border-radius: var(--radius-lg); padding: var(--padding-card); transition: all 0.3s ease; position: relative; display: flex; flex-direction: column; margin-bottom: var(--margin-base); color: var(--brand-text); }
.card-interactive { cursor: pointer; transition: all 0.2s; border: 1px solid transparent; }
@media (hover: hover) { .card-interactive:hover { border-color: var(--brand-primary) !important; background-color: var(--color-info-bg); transform: translateY(-2px); } }
.card-interactive.selected { border-color: var(--brand-primary) !important; background-color: var(--color-info-bg); }
.card-select { background: var(--surface-bg); border: 1px solid var(--ui-border); border-radius: var(--radius-lg); padding: var(--padding-card); cursor: pointer; transition: all 0.3s ease; position: relative; display: flex; flex-direction: column; justify-content: center; align-items: center; }
@media (hover: hover) { .card-select:hover { border-color: var(--brand-primary); transform: translateY(-2px); } }
.card-select.selected { border-color: var(--brand-primary); background-color: var(--color-info-bg); box-shadow: 0 0 0 1px var(--brand-primary); }
.card-select-header { text-align: center; margin-bottom: 8px; color: var(--brand-text); }
.card-pricing { border: 1px solid var(--ui-border); border-radius: var(--radius-lg); padding: var(--padding-card); background: var(--surface-bg); transition: all 0.3s ease; display: flex; flex-direction: column; justify-content: space-between; height: 100%; position: relative; }
@media (hover: hover) { .card-pricing:hover { transform: translateY(-4px); box-shadow: 0 12px 24px rgba(0,0,0,0.1); } }
.card-pricing.standard { border-color: var(--brand-primary); background-color: var(--color-info-bg); }
.card-pricing.premium { border-color: var(--color-success-text); background-color: var(--color-success-bg); }
.badge-floating { position: absolute; top: 0; left: 50%; transform: translate(-50%, -50%); background-color: var(--color-success-text); color: #fff; font-size: var(--font-size-sm); font-weight: 600; padding: 4px 12px; border-radius: 20px; white-space: nowrap; box-shadow: 0 2px 4px rgba(0,0,0,0.1); }

/* Badges (Mathematically Scaled - Small Text) */
.badge { display: inline-flex; align-items: center; padding: 0.25em 0.6em; border-radius: 9999px; font-size: var(--font-size-sm); font-weight: 600; line-height: 1; border: 1px solid transparent; white-space: nowrap; }
.badge-excellent { background-color: var(--color-success-bg); color: var(--color-success-text); border-color: var(--color-success-bg); }
.badge-good { background-color: var(--color-info-bg); color: var(--brand-primary); border-color: var(--color-info-bg); }
.badge-normal { background-color: var(--color-warning-bg); color: var(--color-warning-text); border-color: var(--color-warning-bg); }
.badge-poor { background-color: var(--color-danger-bg); color: var(--color-danger-text); border-color: var(--color-danger-bg); }

/* Layout Containers */
// .content-area { background: var(--surface-bg); border-radius: var(--radius-lg); border: 1px solid var(--ui-border); box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04), 0px 1px 3px rgba(0, 0, 0, 0.02); overflow: hidden; height: 100%; display: flex; flex-direction: column; }
.content-area { overflow: hidden; height: 100%; display: flex; flex-direction: column; }
.panel-header { border-bottom: 1px solid var(--ui-border); background: var(--surface-bg); padding: var(--padding-card); display: flex; justify-content: space-between; align-items: center; transition: padding 0.3s ease; }
.assessment-table { background: var(--surface-bg); border-bottom: 1px solid var(--ui-border); flex: 1; overflow-x: auto; overflow-y: auto; scrollbar-width: thin; scrollbar-color: var(--ui-border) var(--surface-bg); }

/* VWO Cards */
.VWOcard { position: relative; width: 100%; max-width: 200px; min-height: 160px; background-color: var(--surface-bg); border-radius: var(--radius-md); padding: 16px 0; box-shadow: 0px 4px 6px 2px rgba(16,24,40,0.03); display: flex; align-items: center; justify-content: center; flex-direction: column; gap: 12px; border: 1px solid transparent; transition: all 0.2s; cursor: pointer;}
.VWOcard:hover { border-color: var(--brand-primary); }
.orngBrdr { border: 2px solid var(--color-danger-text); }
.vwo-icon-wrapper { width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; background-color: var(--color-info-bg); color: var(--brand-primary); }
.vwo-icon-wrapper.danger { background-color: var(--color-danger-bg); color: var(--color-danger-text); }

/* Modals */
.custom-modal-overlay { position: fixed; inset: 0; background-color: rgba(0,0,0,0.5); backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px); z-index: var(--ff-z-index-modal); display: flex; align-items: center; justify-content: center; animation: fadeIn 0.2s ease-out; }
.custom-modal-dialog { background: var(--surface-bg); width: 100%; max-width: 500px; max-height: 90vh; border-radius: var(--radius-lg); box-shadow: 0 10px 25px rgba(0,0,0,0.2); display: flex; flex-direction: column; overflow: hidden; animation: slideUp 0.3s ease-out; }
.custom-modal-header { padding: 1rem 1.5rem; border-bottom: 1px solid var(--ui-border); display: flex; justify-content: space-between; align-items: center; background: var(--surface-bg); }
.custom-modal-body { padding: 1.5rem; flex: 1; overflow-y: auto; background: var(--surface-bg); scrollbar-width: thin; scrollbar-color: var(--ui-border) var(--surface-bg); }
.custom-modal-footer { padding: 1rem 1.5rem; border-top: 1px solid var(--ui-border); background: var(--surface-bg-hover); display: flex; justify-content: flex-end; gap: 1rem; }

@keyframes slideInRight { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
@keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

/* ==========================================================================
   ADDED UTILITY CLASSES FOR WIZARD LAYOUT
   ========================================================================== */
.z-10 { z-index: 10; }
.z-1060 { z-index: 1060; }
.z-1020 { z-index: 1020; }
.progress-thin { height: 6px; }
.cursor-pointer { cursor: pointer; }
.modal-md { max-width: 500px; }
.modal-lg { max-width: 600px; }
.modal-body-scroll { max-height: 70vh; overflow-y: auto; }
.h-auto { height: auto !important; }
.avatar-56 { width: 56px; height: 56px; flex-shrink: 0; }
.logo-text { letter-spacing: 0.5px; }
.max-w-400 { max-width: 400px; margin: 0 auto; }
.max-w-500 { max-width: 500px; margin: 0 auto; }
.max-w-900 { max-width: 900px; margin: 0 auto; }
.min-w-60 { min-width: 60px; }
.step-action-label { min-width: 60px; text-align: start; }
.min-w-100 { min-width: 100px; }
.process-connector { position: absolute; top: 50%; left: 0; width: 100%; border-top: 2px solid var(--ui-border); z-index: 0; transform: translateY(-40px); pointer-events: none; }
.step-icon-box { width: 72px; height: 72px; position: relative; z-index: 1; }
.action-header { letter-spacing: 1px; }
.selection-row { cursor: pointer; transition: all 0.2s; border: 1px solid transparent; z-index: 10; position: relative; }
.selection-row:hover { transform: translateY(-2px); border-color: var(--brand-primary); }
.icon-box-56 { width: 56px; height: 56px; }
.country-code-select { width: 100px; flex-shrink: 0; }
.badge-autofill { background-color: var(--color-info-bg); border-color: var(--brand-primary); color: var(--brand-primary); font-weight: 600; border: 1px solid; font-size: 0.5rem; padding: 2px 6px; line-height: 1; height: max-content; }
.form-half-width { width: 100%; }
@media (min-width: 768px) { .form-half-width { width: 50%; } }
.animate-spin { animation: spin 1s linear infinite; }
@keyframes spin { 100% { transform: rotate(360deg); } }

/* Light Blue Disabled State matching latest screenshots */
.btn-completed { 
  cursor: default !important; 
  opacity: 1 !important; 
  transform: none !important; 
  pointer-events: none; 
  background-color: #B3D4FF !important; 
  border-color: #B3D4FF !important; 
  color: #ffffff !important; 
}

.dropdown-item-hover { transition: background-color 0.2s; }
.dropdown-item-hover:hover { background-color: var(--ui-gray-bg); color: var(--brand-primary); }

.sticky-action-bar { position: fixed; bottom: 0; left: 0; width: 100%; padding: 1rem 1.5rem; border-top: 1px solid rgba(208, 213, 221, 0.6); background: rgba(255, 255, 255, 0.65); backdrop-filter: blur(16px) saturate(180%); -webkit-backdrop-filter: blur(16px) saturate(180%); box-shadow: 0 -4px 24px -6px rgba(0,0,0,0.08); z-index: 1020; }
.toast-container { position: absolute; bottom: 20px; right: 20px; z-index: 1100; display: flex; flex-direction: column; gap: 10px; }
.toast { background: var(--surface-bg); border: 1px solid var(--ui-border); border-radius: 8px; padding: 12px 16px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); display: flex; align-items: center; gap: 12px; min-width: 300px; animation: slideInRight 0.3s ease-out; }

/* --- ADDED FOR RESPONSIVE ADJUSTMENTS --- */
.step-icon-responsive { width: 48px; height: 48px; border: 1px solid var(--ui-gray-bg); }
.step-icon-responsive svg { width: 24px !important; height: 24px !important; }
.header-logo-box { width: 64px; height: 64px; flex-shrink: 0; }
@media (min-width: 768px) {
  .step-icon-responsive { width: 72px; height: 72px; }
  .step-icon-responsive svg { width: 32px !important; height: 32px !important; }
}
@media (max-width: 575.98px) {
  .header-logo-box { width: 76px; height: 76px; }
}

@media (max-width: 575.98px) {
  .step-action-label { min-width: 52px !important; text-align: end !important; }
  .step-action-label button { text-align: end !important; }
  .received-heading { font-size: 0.9rem !important; letter-spacing: 0 !important; white-space: nowrap; }
  .received-heading-row { flex-direction: row !important; align-items: center !important; justify-content: center !important; position: relative !important; flex-wrap: nowrap !important; }
  .received-heading-row .received-spacer { display: block !important; flex: 1 !important; }
  .received-heading-row .share-link-container { position: static !important; transform: none !important; flex: 1 !important; display: flex !important; justify-content: flex-end !important; }
  .received-heading-row .share-link-container button { padding: 2px 4px !important; }
  .received-heading-row .share-link-container button svg { width: 18px !important; height: 18px !important; }
  .received-thumb { width: 20px !important; height: 20px !important; }
}

@media (max-width: 390px) {
  .received-heading { font-size: 0.8rem !important; }
}

`;

// --- 3. MOCK DATA & CONSTANTS ---
const LYWOLogoSmall = "https://placehold.co/56x56?text=LOGO";
const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);

const DEFAULT_JOB_DATA = {
  code: "1060AB7",
  position: "Marketing Engineer",
  companyname: "Rapsri Engineering Products Pvt Ltd",
  companyLogo: "/path/to/logo.png",
};

const JOB_DESCRIPTION_TEXT = `
ROLE: Marketing Engineer
COMPANY: Rapsri Engineering Products Pvt Ltd
JOB ID: 1060AB7

BRIEF JOB DESCRIPTION:
We seek a proactive Marketing Engineer to drive our marketing initiatives and support business growth at Rapsri Engineering Products Pvt Ltd.

JOB DETAILS:
- Industry: Engineering, Technical & Equipment Manufacturing
- Location: Bengaluru
- Compensation: 4.5 to 5.5 LPA
- Type: Full-time
- Qualification: Bachelor's
`;

const MOCK_JOB_DATA = {
  code: "1060AB7",
  position: "Marketing Engineer",
  aboutJob: "We seek a proactive Marketing Engineer to drive our marketing initiatives and support business growth.",
  companyname: "Rapsri Engineering Products Pvt Ltd",
  companyLogo: "/path/to/logo.png",
  aboutCompany: "Rapsri Engineering Products Pvt Ltd is a leader in Engineering, Technical & Equipment Manufacturing. We specialize in producing high-quality engineering products for global markets.",
  companyDetails: {
    overview: "Rapsri Engineering Products Pvt Ltd is a premier manufacturing entity dedicated to precision and innovation. Our mission is to deliver world-class engineering solutions while upholding values of integrity, quality, and sustainability.",
    industryPresence: "A dominant player in the Engineering, Technical & Equipment Manufacturing sector based in Bengaluru. We have a robust global footprint, exporting to over 30 countries.",
    productsServices: "We specialize in copper and copper alloy castings, gravity die castings, and precision machined components relevant to automotive and electrical industries.",
    culture: "We foster a collaborative and inclusive work environment that values continuous learning. Employees enjoy comprehensive health benefits, flexible work arrangements, and team-building retreats.",
    awards: "Recipient of the 'Excellence in Manufacturing' award 2023 and ISO 9001:2015 certified for quality management systems.",
    growth: "We are expanding our R&D division, offering significant opportunities for internal mobility, leadership training, and skill development programs."
  }
};

const MOCK_PARSED_DATA = {
  name: "Jane Cooper",
  email: "jane.cooper@example.com",
  phone: "9876543210", 
  currentLocation: "Bengaluru, India",
  educationLevel: "Bachelor's", 
  fieldOfEducation: "Engineering",
  experienceYears: "1-2",
  currentJobTitle: "Junior Marketing Associate", 
  currentCompany: "Tech Solutions Ltd",
  departmentId: "MKT",
  currentIndustry: "Manufacturing",
};

const MOCK_CUSTOM_QUESTIONS = [
  { id: 1, questionText: "Do you have experience with SEO/SEM tools?", isActive: true },
  { id: 2, questionText: "Are you willing to relocate to Bengaluru if required?", isActive: true },
  { id: 3, questionText: "Do you have a valid passport for potential global travel?", isActive: true },
];

const MOCK_OPTIONS = {
  education: [
    { label: "High School", value: "High School" },
    { label: "Bachelor's", value: "Bachelor's" },
    { label: "Master's", value: "Master's" },
    { label: "PhD", value: "PhD" },
  ],
  experience: [
    { label: "Fresher", value: "0" },
    { label: "1-3 Years", value: "1-3" },
    { label: "3-5 Years", value: "3-5" },
    { label: "5+ Years", value: "5+" },
  ],
  salary: [
    { label: "₹3L - ₹4.5L", value: "3-4.5" },
    { label: "₹4.5L - ₹5.5L", value: "4.5-5.5" },
    { label: "₹5.5L - ₹8L", value: "5.5-8" },
    { label: "₹8L+", value: "8+" },
  ],
  codes: [
    { dial_code: "+91", code: "IN" },
    { dial_code: "+1", code: "US" },
    { dial_code: "+44", code: "UK" },
  ],
  specialization: [
    { specializationName: "Marketing", specializationId: "MKT" },
    { specializationName: "Engineering", specializationId: "ENG" },
    { specializationName: "Business Administration", specializationId: "BA" },
  ],
  departments: [
    { name: "Marketing", id: "MKT" },
    { name: "Sales", id: "SALES" },
    { name: "Engineering", id: "ENG" },
  ],
  industries: [
    { label: "Manufacturing", value: "MFG" },
    { label: "Technology", value: "TECH" },
    { label: "Consulting", value: "CONS" },
  ],
};

// ==========================================
// 4. SUB-COMPONENTS
// ==========================================

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`text-white border-0 position-fixed top-0 end-0 m-3 z-1060 rounded-2 ${type === "success" ? "bg-success" : "bg-danger"}`}
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 14px', gap: '16px', minWidth: '200px', maxWidth: '320px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', animation: 'slideInRight 0.3s ease-out' }}>
      <span style={{ flex: 1 }}>{message}</span>
      <button type="button" onClick={onClose} style={{ background: 'none', border: 'none', color: 'white', fontSize: '1.1rem', lineHeight: 1, cursor: 'pointer', padding: 0, opacity: 0.85, flexShrink: 0 }}>&#x2715;</button>
    </div>
  );
};

const LocalCustomButton = ({ title, handleClick, isLoading, isIcon, variant = "primary", className = "" }) => (
  <button className={`btn btn-${variant} ${className}`} onClick={handleClick} disabled={isLoading}>
    {isLoading ? <span className="spinner-border spinner-border-sm"></span> : <> {title} {isIcon && <Icons.ChevronRight size={18} />} </>}
  </button>
);

const SearchableSelect = ({ options, value, onChange, name, placeholder = "Select..." }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [dropdownStyle, setDropdownStyle] = useState({});
  const wrapperRef = useRef(null);
  const triggerRef = useRef(null);

  const selectedOption = options.find(o => o.value === value);
  const displayLabel = selectedOption ? selectedOption.label : "";

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside, { passive: true });
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  const openDropdown = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setDropdownStyle({
        position: 'fixed',
        top: rect.bottom + 4,
        left: rect.left,
        width: rect.width,
        zIndex: 9999,
      });
    }
    setIsOpen(prev => !prev);
    setSearch("");
  };

  const filteredOptions = options.filter(o => o.label.toLowerCase().includes(search.toLowerCase()));

  return (
    <div className="w-100" ref={wrapperRef}>
      <div
        ref={triggerRef}
        className="form-control d-flex justify-content-between align-items-center cursor-pointer"
        onClick={openDropdown}
        onTouchEnd={(e) => { e.preventDefault(); openDropdown(); }}
      >
        <span className={displayLabel ? "text-dark" : "text-muted"}>
          {displayLabel || placeholder}
        </span>
        <Icons.ChevronRight size={16} style={{ transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)', transition: '0.2s' }} />
      </div>

      {isOpen && (
        <div className="bg-white border rounded shadow-sm" style={{ ...dropdownStyle, maxHeight: '250px', overflowY: 'auto', WebkitOverflowScrolling: 'touch' }}>
          <div className="p-2 bg-white border-bottom" style={{ position: 'sticky', top: 0, zIndex: 2 }}>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <div className="py-1">
            {filteredOptions.length > 0 ? filteredOptions.map((opt, i) => (
              <div
                key={i}
                className="px-3 py-2 cursor-pointer dropdown-item-hover text-base"
                onClick={() => { onChange({ target: { name, value: opt.value } }); setIsOpen(false); }}
                onTouchEnd={(e) => { e.preventDefault(); onChange({ target: { name, value: opt.value } }); setIsOpen(false); }}
              >
                {opt.label}
              </div>
            )) : (
              <div className="px-3 py-2 text-muted small">No results found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const ResumeUploadModal = ({ isOpen, onClose, onUploadComplete }) => {
  const [phase, setPhase] = useState('idle'); // 'idle' | 'parsing' | 'success'
  const [progress, setProgress] = useState(0);

  if (!isOpen) return null;

  const handleFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setPhase('parsing');
    setProgress(0);

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            setPhase('success');
            setTimeout(() => onUploadComplete(file.name), 1000);
          }, 300);
          return 100;
        }
        return prev + 10;
      });
    }, 200);
  };

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal-dialog modal-md">
        <div className="custom-modal-header">
          <h5 className="fw-bold m-0 text-xl">Upload Resume</h5>
          <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
        </div>
        <div className="custom-modal-body">
          {phase === 'parsing' ? (
            <div className="text-center py-5">
              <Icons.Loader2 className="text-primary mb-3 mx-auto animate-spin" size={40} />
              <h6 className="mt-3 text-lg">Parsing Resume...</h6>
              <div className="progress w-75 mx-auto progress-thin">
                <div className="progress-bar bg-primary progress-bar-striped progress-bar-animated" style={{ width: `${progress}%` }}></div>
              </div>
            </div>
          ) : phase === 'success' ? (
            <div className="text-center py-5">
              <Icons.BadgeCheck className="text-success mb-3 mx-auto" size={48} />
              <h6 className="mt-2 text-lg text-success fw-bold">Resume Parsed Successfully!</h6>
            </div>
          ) : (
            <div className="dropzone py-5 position-relative text-center border rounded bg-light">
              <Icons.UploadCloud className="text-primary mb-2 mx-auto" size={32} />
              <h6 className="text-lg">Drag & drop or click to upload</h6>
              <p className="text-muted text-xs text-center">PDF or DOCX (Max 25MB)</p>
              <input type="file" className="position-absolute w-100 h-100 opacity-0 top-0 start-0 cursor-pointer z-10" onChange={handleFile} onClick={(e) => (e.target.value = null)} accept=".pdf,.doc,.docx" />
            </div>
          )}
        </div>
        {phase === 'idle' && (
          <div className="custom-modal-footer justify-content-end">
            <button className="btn btn-outline-primary" onClick={onClose}>Cancel</button>
          </div>
        )}
      </div>
    </div>
  );
};

const AboutCompanyModal = ({ isOpen, onClose, data }) => {
  if (!isOpen) return null;
  const details = data.companyDetails || {};
  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal-dialog modal-lg">
        <div className="custom-modal-header">
          <h5 className="fw-bold m-0 text-xl">About {data.companyname}</h5>
          <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
        </div>
        <div className="custom-modal-body text-muted small lh-base modal-body-scroll">
            <div className="mb-3">
                <h6 className="fw-bold text-dark mb-1 text-lg">Company Overview</h6>
                <p>{details.overview}</p>
            </div>
            <div className="mb-3">
                <h6 className="fw-bold text-dark mb-1 text-lg">Industry & Market Presence</h6>
                <p>{details.industryPresence}</p>
            </div>
            <div className="mb-3">
                <h6 className="fw-bold text-dark mb-1 text-lg">Products & Services</h6>
                <p>{details.productsServices}</p>
            </div>
            <div className="mb-3">
                <h6 className="fw-bold text-dark mb-1 text-lg">Culture & Work Environment</h6>
                <p>{details.culture}</p>
            </div>
            <div className="mb-3">
                <h6 className="fw-bold text-dark mb-1 text-lg">Awards & Recognition</h6>
                <p>{details.awards}</p>
            </div>
            <div className="mb-0">
                <h6 className="fw-bold text-dark mb-1 text-lg">Growth & Opportunities</h6>
                <p>{details.growth}</p>
            </div>
        </div>
        <div className="custom-modal-footer justify-content-end">
            <button className="btn btn-outline-primary btn-sm" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

const ScoreModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  return (
    <div className="custom-modal-overlay z-1060">
      <div className="custom-modal-dialog modal-md">
        <div className="custom-modal-header">
          <h5 className="fw-bold m-0 text-xl">Technical Assessment</h5>
          <button type="button" aria-label="Close" onClick={onClose} style={{ background: 'none', border: 'none', boxShadow: 'none', outline: 'none', WebkitAppearance: 'none', fontSize: '1.3rem', lineHeight: 1, color: '#000', opacity: 0.5, cursor: 'pointer', padding: '4px 8px' }}>&#x2715;</button>
        </div>
        <div className="custom-modal-body text-center py-5">
          <h4 className="fw-bold text-dark mb-4">Your Score</h4>
          <div className="d-inline-flex align-items-center justify-content-center bg-primary bg-opacity-10 text-primary fw-bold rounded-3 mb-0" style={{fontSize: '3rem', padding: '1rem 2rem'}}>
            5 <span className="text-muted mx-2 text-2xl fw-normal">/</span> 16
          </div>
        </div>
        <div className="custom-modal-footer justify-content-center">
          <button className="btn px-5 py-2 fw-bold" style={{ backgroundColor: 'white', color: '#0d6efd', border: '1.5px solid #0d6efd' }} onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

const PersonalityViewModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  return (
    <div className="custom-modal-overlay z-1060">
      <div className="custom-modal-dialog" style={{ maxWidth: '850px', padding: 0 }}>
        
        {/* Top Banner Section */}
        <div className="position-relative w-100 d-flex flex-column justify-content-center p-4 p-md-5" style={{ backgroundColor: '#FFEBD6', minHeight: '280px' }}>
          <button type="button" className="btn-close position-absolute" style={{ top: '24px', right: '24px', zIndex: 10 }} aria-label="Close" onClick={onClose}></button>
          
          <div className="row align-items-center w-100 mx-0">
            <div className="col-md-6 d-none d-md-flex justify-content-start ps-0">
               {/* Illustration Placeholder */}
               <div className="d-flex align-items-center justify-content-center rounded-3" style={{ width: '240px', height: '180px', backgroundColor: 'rgba(255, 255, 255, 0.4)', border: '2px dashed rgba(249, 115, 22, 0.3)' }}>
                   <div className="text-center">
                       <Icons.User size={48} style={{ color: '#F97316', opacity: 0.6 }} className="mb-2" />
                       <div className="text-muted text-xs fw-bold text-uppercase" style={{ letterSpacing: '1px', color: '#F97316' }}>Illustration Area</div>
                   </div>
               </div>
            </div>
            <div className="col-md-6 text-center text-md-end pe-0">
              <div className="d-inline-flex align-items-center justify-content-center bg-white rounded-circle mb-3 shadow-sm" style={{ width: '72px', height: '72px', border: '2px solid #F97316' }}>
                <span className="fw-bold" style={{ color: '#F97316', fontSize: '2rem' }}>L</span>
              </div>
              <h2 className="fw-bold text-dark mb-0" style={{ fontSize: '2.5rem' }}>Logical Thinker</h2>
            </div>
          </div>
        </div>

        {/* Bottom Content Section */}
        <div className="bg-white p-4 p-md-5" style={{ flex: 1, overflowY: 'auto' }}>
          <p className="text-muted text-base mb-4" style={{ lineHeight: '1.7' }}>
            Logical thinkers are hardworking, logical, and detail-oriented individuals with high critical thinking abilities. Their habit of meticulous preparation, accuracy, and correctness helps them to manage tasks effectively. Despite being shy and mild-mannered, logical thinkers have a strong need to control their environment. They exert rules, structure, and standards, to accomplish their goals, in conflicting situations. Their cautiousness makes them reluctant to reveal information about themselves or their thoughts unless necessary. Being natural risk avoiders, they only undertake tasks when they are completely certain about the outcome.
          </p>

          <hr className="mb-4 text-muted opacity-25" />

          <div className="d-flex flex-column gap-3">
              <div className="row">
                  <div className="col-sm-3 fw-bold text-dark text-base mb-1 mb-sm-0">Strengths</div>
                  <div className="col-sm-9 text-muted text-base">Quality control, handling detail, analyzing data, logical, avoiding the risk, building structure, being deliberate and methodical</div>
              </div>
              <div className="row">
                  <div className="col-sm-3 fw-bold text-dark text-base mb-1 mb-sm-0">Uniqueness</div>
                  <div className="col-sm-9 text-muted text-base">Accuracy; ability to think logically; building structure</div>
              </div>
              <div className="row">
                  <div className="col-sm-3 fw-bold text-dark text-base mb-1 mb-sm-0">Value to Org.</div>
                  <div className="col-sm-9 text-muted text-base">Completes the undertaken task; great at quality control; organizing information</div>
              </div>
              <div className="row">
                  <div className="col-sm-3 fw-bold text-dark text-base mb-1 mb-sm-0">Challenges</div>
                  <div className="col-sm-9 text-muted text-base">Spotting deficiencies first; controlling; lacks assertiveness</div>
              </div>
              <div className="row">
                  <div className="col-sm-3 fw-bold text-dark text-base mb-1 mb-sm-0">Motivations</div>
                  <div className="col-sm-9 text-muted text-base">Certainty of situation and consequences; getting things right</div>
              </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const DemoContextModal = ({ isOpen, onClose, onFill, onShare, onCheckStatus }) => {
  const [view, setView] = useState("selection");
  const [copied, setCopied] = useState(false);

  useEffect(() => { if (isOpen) setView("selection"); setCopied(false); }, [isOpen]);
  if (!isOpen) return null;

  const handleCopyLink = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal-dialog modal-md">
        <div className="custom-modal-header">
          <div className="d-flex align-items-center gap-2">
            {view !== "selection" && (
              <button className="btn p-0 border-0 text-muted" onClick={() => setView("selection")}><Icons.ArrowLeft size={20} /></button>
            )}
            <h5 className="fw-bold m-0 text-xl">{view === "selection" ? "Select Person" : "Share Job"}</h5>
          </div>
          <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
        </div>

        <div className="custom-modal-body">
            {view === "selection" && (
              <div className="row g-3">
                <div className="col-6">
                  <div className="card-interactive p-3 text-center border rounded h-100" onClick={() => { onFill(); onClose(); }}>
                    <div className="mb-2 text-primary d-flex justify-content-center"><Icons.UserPlus size={24} /></div>
                    <h6 className="small fw-bold mb-1 text-lg">New Candidate</h6>
                    <p className="text-muted mb-0 text-base text-center">First time applying</p>
                  </div>
                </div>
                <div className="col-6">
                  <div className="card-interactive p-3 text-center border rounded h-100" onClick={() => { onCheckStatus(); onClose(); }}>
                    <div className="mb-2 text-success d-flex justify-content-center"><Icons.User size={24} /></div>
                    <h6 className="small fw-bold mb-1 text-lg">Existing Candidate</h6>
                    <p className="text-muted mb-0 text-base text-center">Already in system</p>
                  </div>
                </div>
              </div>
            )}

            {view === "share" && (
              <div>
                <div className="input-group mb-4">
                  <span className="input-group-text bg-light border-end-0"><Icons.Link size={16} /></span>
                  <input type="text" className="form-control bg-light border-start-0 text-muted text-lg" value="https://jobs.techinnovate.com/1060" readOnly />
                  <button className="btn btn-primary" onClick={handleCopyLink}>{copied ? <Icons.Check size={16} /> : "Copy"}</button>
                </div>
                <div className="row g-3">
                   <div className="col-6"><button className="btn btn-outline-secondary w-100 d-flex gap-2 py-2 justify-content-center" onClick={() => onShare("WhatsApp")}><Icons.WhatsApp size={18} className="text-success"/> WhatsApp</button></div>
                   <div className="col-6"><button className="btn btn-outline-secondary w-100 d-flex gap-2 py-2 justify-content-center" onClick={() => onShare("LinkedIn")}><Icons.Linkedin size={18} className="text-primary"/> LinkedIn</button></div>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

// ==========================================
// 5. MAIN COMPONENT (App)
// ==========================================
const App = (props) => {
  const {
    industries = MOCK_OPTIONS.industries, 
    specialization = MOCK_OPTIONS.specialization,
    departments = MOCK_OPTIONS.departments,
    customQuestion = MOCK_CUSTOM_QUESTIONS,
  } = props;

  const [details, setDetails] = useState({
    name: "", email: "", countryCode: "+91", phone: "", educationLevel: "", fieldOfEducation: "",
    experienceYears: "", currentJobTitle: "", currentCompany: "", departmentId: "", currentIndustry: "",
    expectedSalary: "", currentLocation: "", availableFrom: "", noticePeriodBuyout: "", 
    uploadResumeName: "", preferredLocation: "", preferredJobType: "", additionalComments: ""
  });

  const [stepStatus, setStepStatus] = useState({ application: 'completed', personality: 'pending', quiz: 'pending' });
  const [showScoreModal, setShowScoreModal] = useState(false);
  const [showPersonalityView, setShowPersonalityView] = useState(false);

  const jobData = { ...DEFAULT_JOB_DATA, ...MOCK_JOB_DATA };
  const [currentStep, setCurrentStep] = useState(1);
  const [applicationFlow, setApplicationFlow] = useState("quick");
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [showDemoModal, setShowDemoModal] = useState(false);
  const [toastMsg, setToastMsg] = useState(null);
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showShareMenu, setShowShareMenu] = useState(false);
  const [shareCopied, setShareCopied] = useState(false);
  const shareMenuRef = useRef(null);

  useEffect(() => {
    const handleOutside = (e) => {
      if (shareMenuRef.current && !shareMenuRef.current.contains(e.target)) setShowShareMenu(false);
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  const handleInputChange = (e) => setDetails((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 25 * 1024 * 1024) {
        setToastMsg({ type: "error", message: "File too large" });
      } else {
        setDetails({ ...details, uploadResumeName: file.name });
        setErrors({ ...errors, resume: "" });
      }
    }
  };

  const handleResumeParsed = (fileName) => {
    setShowResumeModal(false);
    setDetails((prev) => ({ ...prev, uploadResumeName: fileName, ...MOCK_PARSED_DATA }));
    setToastMsg({ type: "success", message: "Resume parsed successfully!" });
    setCurrentStep(2);
  };

  const handleDemoFillClick = () => { currentStep === 2 ? setShowDemoModal(true) : fillMockData(); };
  const handleCheckApplicationStatus = () => { fillMockData(); setIsSubmitted(true); };

  const fillMockData = () => {
    const mockUpdates = {
      name: "Jane Cooper", email: "jane.cooper@example.com", phone: "9876543210", currentLocation: "Bengaluru, KA",
      educationLevel: "Bachelor's", fieldOfEducation: "MKT", experienceYears: "1-3", currentJobTitle: "Marketing Associate",
      currentCompany: "Tech Solutions", currentSalary: "4.5-5.5", availableFrom: "2026-02-01", expectedSalary: "4.5-5.5",
      noticePeriodBuyout: "No", customQuestion1: "Yes", customQuestion2: "Yes", customQuestion3: "Yes",
      preferredLocation: "Bengaluru", additionalComments: "I am eager to join the team and contribute to your marketing goals.",
    };
    if (applicationFlow === "standard") mockUpdates.uploadResumeName = "jane_cooper_resume.pdf";
    setDetails((prev) => ({ ...prev, ...mockUpdates }));
    setErrors({});
    setToastMsg({ type: "success", message: "✨ Demo data filled!" });
  };

  const handleShareJob = (platform) => {
    setToastMsg({ type: "success", message: `Job Shared via ${platform || "Link"}!` });
    if (platform) setShowDemoModal(false);
  };

  const handleDownloadJD = () => {
    const element = document.createElement("a");
    const file = new Blob([JOB_DESCRIPTION_TEXT], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "Rapsri_Marketing_Engineer_JD.txt";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    setToastMsg({ type: "success", message: "JD Downloaded" });
  };

  const handleStartPersonality = () => {
    setToastMsg({ type: "success", message: "Behavioral Assessment Started..." });
    setTimeout(() => {
        setStepStatus(prev => ({ ...prev, personality: 'completed' }));
        setToastMsg({ type: "success", message: "Behavioral Assessment Completed!" });
    }, 1500);
  };

  const handleStartQuiz = () => {
    setToastMsg({ type: "success", message: "Technical Assessment Started..." });
    setTimeout(() => {
        setStepStatus(prev => ({ ...prev, quiz: 'completed' }));
        setToastMsg({ type: "success", message: "Technical Assessment Completed!" });
    }, 1500);
  };

  const allStepsCompleted = stepStatus.application === 'completed' && stepStatus.personality === 'completed' && stepStatus.quiz === 'completed';

  const validateCurrentStep = () => {
    const newErrors = {};
    let isValid = true;
    const requireField = (field, label) => {
      if (!details[field] || details[field] === "") { newErrors[field] = `${label || field} is required`; isValid = false; }
    };

    if (currentStep === 2) {
      requireField("name", "Full Name"); requireField("email", "Email"); requireField("phone", "Phone Number");
      if (details.email && !isValidEmail(details.email)) { newErrors.email = "Invalid email format"; isValid = false; }
      requireField("currentLocation", "Location");
    } else if (currentStep === 3) {
      requireField("educationLevel", "Education Level"); requireField("fieldOfEducation", "Field of Education"); requireField("experienceYears", "Experience");
      if (details.experienceYears !== "0") { requireField("currentJobTitle", "Job Title"); requireField("currentCompany", "Company"); requireField("currentSalary", "Current Salary"); }
    } else if (currentStep === 4) {
      if (applicationFlow === "standard" && !details.uploadResumeName) { newErrors.resume = "Please upload your resume"; isValid = false; }
      requireField("expectedSalary", "Expected Salary"); requireField("availableFrom", "Availability Date"); requireField("noticePeriodBuyout", "Buyout Option");
      customQuestion.forEach((q, i) => {
        const key = `customQuestion${i + 1}`;
        if (!details[key]) { newErrors[key] = "Please answer this question"; isValid = false; }
      });
    }
    setErrors(newErrors);
    return isValid;
  };

  const handleNext = () => {
    if (validateCurrentStep()) {
      if (currentStep < 4) { setCurrentStep((prev) => prev + 1); window.scrollTo(0, 0); } 
      else { setToastMsg({ type: "success", message: "Application Submitted Successfully!" }); setStepStatus(prev => ({ ...prev, application: 'completed' })); setIsSubmitted(true); }
    } else {
      setToastMsg({ type: "error", message: "Please fix the errors." });
    }
  };

  const renderInput = ({ label, name, type = "text", ...rest }) => (
    <div className="mb-3">
      <label className="form-label d-flex justify-content-between align-items-center mb-1">
        <span>{label} {rest.required && <span className="text-danger">*</span>}</span>
        {applicationFlow === "quick" && details[name] && (
          <span className="d-inline-flex align-items-center rounded-pill badge-autofill" title="Auto-filled from Resume">
            Auto-filled
          </span>
        )}
      </label>
      <input type={type} name={name} className={`form-control bg-white ${errors[name] ? "is-invalid" : ""}`} value={details[name] || ""} onChange={handleInputChange} {...rest} />
      {errors[name] && <div className="text-danger small mt-1">{errors[name]}</div>}
    </div>
  );

  if (isSubmitted) {
    const completedCount = [stepStatus.application, stepStatus.personality, stepStatus.quiz].filter(s => s === 'completed').length;
    const remainingCount = 3 - completedCount;

    const handleCopyLink = () => {
      setShareCopied(true);
      setTimeout(() => setShareCopied(false), 2000);
      setShowShareMenu(false);
    };

    const shareToSocial = (platform) => {
      const url = window.location.href;
      const text = encodeURIComponent(`Check out this job - ${jobData.position}!`);
      const encodedUrl = encodeURIComponent(url);
      const map = {
        linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
        twitter:  `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${text}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
        whatsapp: `https://api.whatsapp.com/send?text=${text}%20${encodedUrl}`,
      };
      if (map[platform]) window.open(map[platform], '_blank', 'noopener,noreferrer');
      setShowShareMenu(false);
    };

    return (
      <div className="ds-wrapper w-100">
        <style>{CUSTOM_CSS}</style>
        <ScoreModal isOpen={showScoreModal} onClose={() => setShowScoreModal(false)} />
        <PersonalityViewModal isOpen={showPersonalityView} onClose={() => setShowPersonalityView(false)} />
        <AboutCompanyModal isOpen={showAboutModal} onClose={() => setShowAboutModal(false)} data={jobData} />
        {toastMsg && <Toast {...toastMsg} onClose={() => setToastMsg(null)} />}

        <div className="container content-area mt-3 bg-white border-0 shadow-none" style={{ overflow: 'visible' }}>
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-11">
              <div className="p-4 text-center position-relative" style={{ overflow: 'visible' }}>

                {/* Heading row: spacer | title+icon | share link — all on one line */}
                <div className="d-flex align-items-center mb-4 received-heading-row">
                  <div className="received-spacer" style={{ flex: 1 }}></div>
                  <div className="d-flex align-items-center gap-2">
                    <h2 className="fw-bold mb-0 text-uppercase received-heading" style={{ color: 'var(--color-gray-600, #475467)', fontSize: '1.5rem' }}>APPLICATION RECEIVED !</h2>
                    <Icons.ThumbsUpSolid className="received-thumb" style={{ marginTop: '-6px', flexShrink: 0, width: '28px', height: '28px' }} />
                  </div>
                  <div className="share-link-container" style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }} ref={shareMenuRef}>
                    <div style={{ position: 'relative', marginRight: '-5px' }}>
                      <button className="btn btn-ghost text-primary d-flex align-items-center p-1" onClick={() => setShowShareMenu(prev => !prev)} title="Share Link">
                        <Icons.Share2 size={22} />
                      </button>
                      {showShareMenu && (
                        <div className="position-absolute bg-white border rounded-3 shadow p-2 mt-1" style={{ top: '100%', right: 0, zIndex: 1055, minWidth: '180px', overflow: 'visible' }}>
                          {[
                            { key: 'linkedin', label: 'LinkedIn', icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="#0A66C2"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg> },
                            { key: 'twitter',  label: 'X (Twitter)', icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg> },
                            { key: 'facebook', label: 'Facebook',   icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="#1877F2"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg> },
                            { key: 'whatsapp', label: 'WhatsApp',   icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="#25D366"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.347-.272.297-1.04 1.016-1.04 2.479 0 1.463 1.065 2.876 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/></svg> },
                          ].map(({ key, label, icon }) => (
                            <button key={key} className="btn btn-ghost w-100 justify-content-start text-dark py-2 gap-2" onClick={() => shareToSocial(key)}>
                              {icon} {label}
                            </button>
                          ))}
                          <hr className="my-1" style={{ opacity: 0.25 }} />
                          <button className="btn btn-ghost w-100 justify-content-start text-primary py-2 gap-2" onClick={handleCopyLink}>
                            <Icons.Link size={15} /> {shareCopied ? 'Copied!' : 'Copy Link'}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <p className="text-muted mb-5 text-base text-center">Hello <strong className="text-dark">{details.name || "Jane Cooper"}</strong>, here is the status of your application process for <strong className="text-dark">{jobData.position}</strong>.</p>

                <div className="d-grid gap-3 max-w-500 mx-auto mb-5">
                  <div className="w-100 d-flex align-items-center gap-3">
                    {stepStatus.application === 'completed'
                      ? <button className="btn btn-completed py-2 px-3 w-100 fw-bold flex-grow-1 text-center">Application Completed</button>
                      : <button className="btn btn-primary py-2 px-3 w-100 fw-bold flex-grow-1 text-center" onClick={() => setIsSubmitted(false)}>Complete Application</button>}
                    <div className="step-action-label text-start text-sm-start">
                      <button className={`btn btn-link fw-bold p-0 text-decoration-none ${stepStatus.application === 'completed' ? 'text-primary' : 'text-muted opacity-50'}`} style={{ cursor: stepStatus.application === 'completed' ? 'pointer' : 'not-allowed' }} onClick={() => stepStatus.application === 'completed' && setIsSubmitted(false)}>Edit</button>
                    </div>
                  </div>
                  <div className="w-100 d-flex align-items-center gap-3">
                    {stepStatus.personality === 'completed'
                      ? <button className="btn btn-completed py-2 px-3 w-100 fw-bold flex-grow-1 text-center">Personality Test completed</button>
                      : <button className="btn btn-primary py-2 px-3 w-100 fw-bold flex-grow-1 text-center" onClick={handleStartPersonality}>Start Personality Test</button>}
                    <div className="step-action-label text-start text-sm-start">
                      <button className={`btn btn-link fw-bold p-0 text-decoration-none ${stepStatus.personality === 'completed' ? 'text-primary' : 'text-muted opacity-50'}`} style={{ cursor: stepStatus.personality === 'completed' ? 'pointer' : 'not-allowed' }} onClick={() => stepStatus.personality === 'completed' && setShowPersonalityView(true)}>View</button>
                    </div>
                  </div>
                  <div className="w-100 d-flex align-items-center gap-3">
                    {stepStatus.quiz === 'completed'
                      ? <button className="btn btn-completed py-2 px-3 w-100 fw-bold flex-grow-1 text-center">Short Quiz completed</button>
                      : <button className="btn btn-primary py-2 px-3 w-100 fw-bold flex-grow-1 text-center" onClick={handleStartQuiz}>Start Short Quiz</button>}
                    <div className="step-action-label text-start text-sm-start">
                      <button className={`btn btn-link fw-bold p-0 text-decoration-none ${stepStatus.quiz === 'completed' ? 'text-primary' : 'text-muted opacity-50'}`} style={{ cursor: stepStatus.quiz === 'completed' ? 'pointer' : 'not-allowed' }} onClick={() => stepStatus.quiz === 'completed' && setShowScoreModal(true)}>Score</button>
                    </div>
                  </div>
                </div>

                <div className="animate-fade-in pt-4 border-top max-w-500 mx-auto">
                  {allStepsCompleted ? (
                    <div className="mb-5 text-center px-3">
                      <h4 className="fw-bold mb-2 text-xl text-dark">We have your Complete Application</h4>
                      <p className="text-muted text-base mb-0 text-center" style={{ textAlign: 'center' }}>Thank you for your Time. We will reach out to you soon.</p>
                    </div>
                  ) : (
                    <div className="mb-5 text-center px-3">
                      <h4 className="fw-bold mb-2 text-lg text-dark">{completedCount} of 3 Steps Complete</h4>
                      <p className="text-muted text-base mb-0 text-center">Kindly complete the remaining {remainingCount} step{remainingCount !== 1 ? 's' : ''} by clicking the start option provided above.</p>
                    </div>
                  )}

                  <div className="max-w-500 mx-auto text-start mb-5">
                    <h4 className="fw-bold mb-4 text-lg text-center text-dark">My Documents</h4>
                    <div className="d-flex flex-column gap-3">
                      {[
                        { label: 'Resume', sub: details.uploadResumeName || 'jane_cooper_resume.pdf', onClick: undefined },
                        { label: 'Job Description', sub: `${jobData.position}.pdf`, onClick: handleDownloadJD },
                        { label: 'About Company', sub: 'Company_Overview.pdf', onClick: () => setShowAboutModal(true) },
                      ].map(({ label, sub, onClick }) => (
                        <div key={label} className="p-3 border rounded-3 d-flex justify-content-between align-items-center bg-white shadow-sm">
                          <div className="d-flex align-items-center gap-3">
                            <div className="text-primary bg-primary bg-opacity-10 p-2 rounded"><Icons.FileText size={20} /></div>
                            <div className="overflow-hidden">
                              <div className="fw-bold text-base text-dark">{label}</div>
                              <div className="text-muted text-xs text-truncate">{sub}</div>
                            </div>
                          </div>
                          <button className="btn btn-sm btn-outline-primary px-4 py-1 rounded-pill flex-shrink-0" onClick={onClick}>View</button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="ds-wrapper w-100">
      <style>{CUSTOM_CSS}</style>
      <ResumeUploadModal isOpen={showResumeModal} onClose={() => setShowResumeModal(false)} onUploadComplete={handleResumeParsed} />
      <AboutCompanyModal isOpen={showAboutModal} onClose={() => setShowAboutModal(false)} data={jobData} />
      <DemoContextModal isOpen={showDemoModal} onClose={() => setShowDemoModal(false)} onFill={fillMockData} onShare={handleShareJob} onCheckStatus={handleCheckApplicationStatus} />
      {toastMsg && <Toast {...toastMsg} onClose={() => setToastMsg(null)} />}

      <div className={`container content-area mt-3 w-100 ${currentStep === 1 ? 'step-one-clean' : ''}`}>
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-12" style={currentStep > 1 && !isSubmitted ? { paddingBottom: '80px' } : {}}>
            
            {/* Header: Simplified and grouped for flawless mobile responsiveness */}
            <div className="bg-white border rounded-3 p-3 p-md-4 mb-4 shadow-sm">
                <div className="d-flex align-items-start gap-3 w-100">
                    <div className="border rounded d-flex align-items-center justify-content-center bg-light text-secondary header-logo-box">
                        <span className="fw-bold logo-text text-base">LOGO</span>
                    </div>
                    <div className="d-flex flex-column justify-content-center flex-grow-1 gap-2">
                        {/* Row 1: Position | Job Description (desktop only right) */}
                        <div className="d-flex align-items-center justify-content-between w-100 lh-1">
                            <h4 className="fw-bold mb-0 text-dark text-lg text-md-xl">{jobData.position}</h4>
                            <button className="text-action-link text-sm fw-bold d-none d-md-block" onClick={handleDownloadJD}>Job Description</button>
                        </div>
                        {/* Row 2: Company | About Us (desktop only right) */}
                        <div className="d-flex align-items-center justify-content-between w-100 lh-1">
                            <div className="text-muted text-sm text-md-base">{jobData.companyname}</div>
                            <button className="text-action-link text-sm fw-bold d-none d-md-block" onClick={() => setShowAboutModal(true)}>About Us</button>
                        </div>
                        {/* Row 3: Links — mobile only */}
                        <div className="d-flex d-md-none align-items-center gap-2 lh-1">
                            <button className="text-action-link text-sm fw-bold" onClick={handleDownloadJD}>Job Description</button>
                            <span className="text-muted opacity-50" style={{fontSize: '12px'}}>|</span>
                            <button className="text-action-link text-sm fw-bold" onClick={() => setShowAboutModal(true)}>About Us</button>
                        </div>
                    </div>
                </div>
            </div>

            {currentStep === 1 ? (
                 <div className="animate-fade-in py-2">
                    <div className="text-center mb-5 mt-4">
                        <h2 className="fw-bold h3 mb-3 text-dark">Thank you for your Interest in the Job.</h2>
                        <div className="d-inline-flex align-items-center justify-content-center gap-2 text-muted mb-2 w-100" style={{maxWidth: '360px', margin: '0 auto'}}>
                            <Icons.Clock size={18} style={{flexShrink: 0, alignSelf: 'flex-start', marginTop: '3px'}} />
                            <span className="text-lg">The process has 3 Steps and will take only 15-20 minutes</span>
                        </div>
                    </div>

                    <div className="row g-3 mb-5 justify-content-center position-relative px-2 px-md-4">
                        <div className="position-absolute border-top d-none d-md-block" style={{ top: '36px', left: '10%', width: '80%', zIndex: 0, borderColor: '#e5e7eb' }}></div>
                        
                        <div className="col-12 col-md-4 position-relative z-10">
                            <div className="d-flex flex-column align-items-center text-center gap-2 gap-md-0">
                                <div className="mb-0 mb-md-3 bg-white rounded-circle shadow-sm d-flex align-items-center justify-content-center flex-shrink-0 step-icon-responsive" style={{ color: 'var(--color-blue-500)' }}>
                                    <Icons.FileText />
                                </div>
                                <div>
                                    <h5 className="fw-bold mb-1 mb-md-2 text-base text-dark">Application</h5>
                                    <p className="text-muted small text-xs px-0 px-md-3 mb-0 text-center">Share your resume and basic contact info.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-4 position-relative z-10">
                            <div className="d-flex flex-column align-items-center text-center gap-2 gap-md-0">
                                <div className="mb-0 mb-md-3 bg-white rounded-circle shadow-sm d-flex align-items-center justify-content-center flex-shrink-0 step-icon-responsive" style={{ color: 'var(--color-indigo-500)' }}>
                                    <Icons.User />
                                </div>
                                <div>
                                    <h5 className="fw-bold mb-1 mb-md-2 text-base text-dark">Personality Fit</h5>
                                    <p className="text-muted small text-xs px-0 px-md-3 mb-0 text-center">A quick assessment of your work style traits.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-4 position-relative z-10">
                            <div className="d-flex flex-column align-items-center text-center gap-2 gap-md-0">
                                <div className="mb-0 mb-md-3 bg-white rounded-circle shadow-sm d-flex align-items-center justify-content-center flex-shrink-0 step-icon-responsive" style={{ color: 'var(--color-yellow-700)' }}>
                                    <Icons.CheckCircle />
                                </div>
                                <div>
                                    <h5 className="fw-bold mb-1 mb-md-2 text-base text-dark">Short Quiz(If Avail.)</h5>
                                    <p className="text-muted small text-xs px-0 px-md-3 mb-0 text-center">A brief check of your skills relevant to the role.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-10">
                            <h6 className="text-center text-muted fw-bold mb-4 action-header text-sm">2 Ways to Apply</h6>
                            <div className="d-flex align-items-center p-4 mb-4 bg-white shadow-sm border position-relative overflow-hidden selection-row" onClick={() => { setApplicationFlow("quick"); setShowResumeModal(true); }} style={{ borderRadius: '12px' }}>
                                <div className="bg-primary bg-opacity-10 rounded-circle me-4 text-primary d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: '64px', height: '64px' }}>
                                    <Icons.Zap size={28} />
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fw-bold mb-1 text-dark text-lg">Quick Apply</h5>
                                    <p className="text-muted mb-0 small text-sm">Upload Resume </p>
                                </div>
                                <div className="text-dark ms-3"><Icons.ChevronRight size={20} /></div>
                            </div>
                            <div className="d-flex align-items-center p-4 bg-white shadow-sm border position-relative overflow-hidden selection-row" onClick={() => { setApplicationFlow("standard"); setCurrentStep(2); }} style={{ borderRadius: '12px' }}>
                                <div className="bg-secondary bg-opacity-10 rounded-circle me-4 text-secondary d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: '64px', height: '64px' }}>
                                    <Icons.Edit size={28} />
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fw-bold mb-1 text-dark text-lg">Manual Entry</h5>
                                    <p className="text-muted mb-0 small text-sm">Fill Manually</p>
                                </div>
                                <div className="text-dark ms-3"><Icons.ChevronRight size={20} /></div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="card-std d-flex flex-column card-auto-height">
                <div className="flex-grow-1">
                    {currentStep === 2 && (
                    <div className="animate-fade-in">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="fw-bold mb-0 text-lg">Basic Info</h5>
                        <button onClick={handleDemoFillClick} className="btn btn-link text-decoration-none text-muted p-0 d-flex align-items-center gap-1 text-lg"><Icons.Sparkles size={14} /> Demo</button>
                        </div>
                        {renderInput({ label: "Full Name", name: "name", required: true })}
                        {renderInput({ label: "Email", name: "email", required: true })}
                        <div className="mb-3">
                        <label className="form-label mb-1">Phone <span className="text-danger">*</span></label>
                        <div className="d-flex gap-2 w-100">
                            <div className="country-code-select">
                            <SearchableSelect 
                                name="countryCode" 
                                value={details.countryCode} 
                                onChange={handleInputChange}
                                options={MOCK_OPTIONS.codes.map((c) => ({ value: c.dial_code, label: c.dial_code }))}
                                placeholder="Code"
                            />
                            </div>
                            <input type="tel" className="form-control flex-grow-1" name="phone" value={details.phone} onChange={handleInputChange} />
                        </div>
                        </div>
                        {renderInput({ label: "Location", name: "currentLocation", required: true })}
                    </div>
                    )}

                    {currentStep === 3 && (
                    <div className="animate-fade-in">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="fw-bold mb-0 text-lg">Education & Experience</h5>
                        <button onClick={handleDemoFillClick} className="btn btn-link text-decoration-none text-muted p-0 d-flex align-items-center gap-1 text-lg"><Icons.Sparkles size={14} /> Demo</button>
                        </div>
                        <div className="mb-3">
                        <label className="form-label mb-1">Education Level <span className="text-danger">*</span></label>
                        <SearchableSelect 
                            name="educationLevel" 
                            value={details.educationLevel} 
                            onChange={handleInputChange}
                            options={MOCK_OPTIONS.education}
                        />
                        </div>
                        <div className="mb-3">
                        <label className="form-label mb-1">Field of Education <span className="text-danger">*</span></label>
                        <SearchableSelect 
                            name="fieldOfEducation" 
                            value={details.fieldOfEducation} 
                            onChange={handleInputChange}
                            options={specialization.map((s) => ({ value: s.specializationId, label: s.specializationName }))}
                        />
                        </div>
                        <div className="mb-3">
                        <label className="form-label mb-1">Experience (in years) <span className="text-danger">*</span></label>
                        <SearchableSelect 
                            name="experienceYears" 
                            value={details.experienceYears} 
                            onChange={handleInputChange}
                            options={MOCK_OPTIONS.experience}
                        />
                        </div>
                        
                        <div className="mt-4">
                            <h6 className="fw-bold mb-3 border-bottom pb-2 text-lg">Current Employment</h6>
                            {renderInput({ label: "Job Title", name: "currentJobTitle", required: details.experienceYears !== "0" })}
                            {renderInput({ label: "Company", name: "currentCompany", required: details.experienceYears !== "0" })}
                            <div className="mb-3">
                            <label className="form-label mb-1">Current Salary {details.experienceYears !== "0" && <span className="text-danger">*</span>}</label>
                            <SearchableSelect 
                                name="currentSalary" 
                                value={details.currentSalary} 
                                onChange={handleInputChange}
                                options={MOCK_OPTIONS.salary}
                            />
                            </div>
                            <div className="mb-3">
                            <label className="form-label mb-1">Department</label>
                            <SearchableSelect 
                                name="departmentId" 
                                value={details.departmentId} 
                                onChange={handleInputChange}
                                options={departments.map((d) => ({ value: d.id, label: d.name }))}
                            />
                            </div>
                            <div className="mb-3">
                            <label className="form-label mb-1">Industry</label>
                            <SearchableSelect 
                                name="currentIndustry" 
                                value={details.currentIndustry} 
                                onChange={handleInputChange}
                                options={industries.map((i) => ({ value: i.label, label: i.label }))}
                            />
                            </div>
                        </div>
                    </div>
                    )}

                    {currentStep === 4 && (
                    <div className="animate-fade-in">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="fw-bold mb-0 text-lg">Additional Info</h5>
                        <button onClick={handleDemoFillClick} className="btn btn-link text-decoration-none text-muted p-0 d-flex align-items-center gap-1 text-lg"><Icons.Sparkles size={14} /> Demo</button>
                        </div>
                        
                        <div className="mb-3">
                            <label className="form-label mb-1">Resume {applicationFlow === "standard" && <span className="text-danger">*</span>}</label>
                            <div className={`border rounded p-2 d-flex justify-content-between align-items-center bg-white position-relative ${errors.resume ? "border-danger" : ""}`} style={{ transition: 'border-color 0.2s' }}>
                                <div className="d-flex align-items-center gap-3 overflow-hidden">
                                    <div className="bg-light p-2 rounded text-primary flex-shrink-0">
                                        {details.uploadResumeName ? <Icons.FileText size={20} /> : <Icons.UploadCloud size={20} />}
                                    </div>
                                    <div className="overflow-hidden">
                                        <h6 className="small fw-bold mb-0 text-dark text-truncate">
                                            {details.uploadResumeName ? details.uploadResumeName : "Click to Upload Resume"}
                                        </h6>
                                        <p className="text-muted mb-0 text-xs text-center">PDF, DOCX (Max 25MB)</p>
                                    </div>
                                </div>
                                <div className="flex-shrink-0 ms-2">
                                    <button className="btn btn-sm btn-outline-primary bg-white" tabIndex="-1" style={{pointerEvents: 'none'}}>
                                        {details.uploadResumeName ? "Change" : "Browse"}
                                    </button>
                                </div>
                                <input 
                                    type="file" 
                                    className="position-absolute w-100 h-100 opacity-0 top-0 start-0 cursor-pointer z-10" 
                                    onChange={handleFileChange} 
                                    onClick={(e) => (e.target.value = null)} 
                                    accept=".pdf,.doc,.docx" 
                                    title="Upload Resume" 
                                />
                            </div>
                            {errors.resume && <div className="text-danger small mt-1">{errors.resume}</div>}
                        </div>

                        <div className="mb-3">
                            <label className="form-label mb-1">Expected Salary <span className="text-danger">*</span></label>
                            <SearchableSelect 
                                name="expectedSalary" 
                                value={details.expectedSalary} 
                                onChange={handleInputChange}
                                options={MOCK_OPTIONS.salary}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label mb-1">Available From <span className="text-danger">*</span></label>
                            <input type="date" className="form-control" name="availableFrom" value={details.availableFrom} onChange={handleInputChange} />
                        </div>
                        <div className="mb-3 d-flex justify-content-between align-items-center">
                        <label className="form-label mb-0">Buy Out Option? <span className="text-danger">*</span></label>
                        <div className="d-flex gap-3">
                            {["Yes", "No"].map((o) => (
                            <div key={o} className="form-check mb-0 d-flex align-items-center gap-2">
                                <input className="form-check-input mt-0" type="radio" name="noticePeriodBuyout" id={`buyout-${o}`} value={o} checked={details.noticePeriodBuyout === o} onChange={handleInputChange} />
                                <label className="form-check-label cursor-pointer mb-0" htmlFor={`buyout-${o}`}>{o}</label>
                            </div>
                            ))}
                        </div>
                        </div>

                        <h6 className="fw-bold mt-4 mb-3 border-bottom pb-2 text-lg">Job Related Questions</h6>

                        {customQuestion.map((q, i) => (
                        <div key={i} className="mb-3">
                            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                                <label className="form-label mb-2 mb-md-0">{q.questionText} <span className="text-danger">*</span></label>
                                <div className="d-flex gap-3">
                                {["Yes", "No"].map((o) => (
                                    <div key={o} className="form-check mb-0 d-flex align-items-center gap-2">
                                    <input className="form-check-input mt-0" type="radio" name={`customQuestion${i + 1}`} id={`q${i}-${o}`} value={o} checked={details[`customQuestion${i + 1}`] === o} onChange={handleInputChange} />
                                    <label className="form-check-label cursor-pointer mb-0" htmlFor={`q${i}-${o}`}>{o}</label>
                                    </div>
                                ))}
                                </div>
                            </div>
                            {errors[`customQuestion${i + 1}`] && <div className="text-danger small text-end mt-1">{errors[`customQuestion${i + 1}`]}</div>}
                        </div>
                        ))}
                    </div>
                    )}
                </div>
                </div>
            )}
          </div>
        </div>
      </div>

      {!isSubmitted && currentStep > 1 && (
        <div className="sticky-action-bar position-fixed bottom-0 start-0 w-100 z-1020">
          <div className="container w-100 d-flex justify-content-between align-items-center px-0 max-w-900">
            <div className="min-w-100" style={{ marginLeft: '18px' }}>
              <LocalCustomButton title="Back" handleClick={() => setCurrentStep((c) => c - 1)} variant="outline-primary" />
            </div>
            <div className="min-w-100 text-end" style={{ marginRight: '18px' }}>
              <LocalCustomButton title={currentStep === 4 ? "Submit" : "Next"} handleClick={handleNext} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;

